
export const SOCIAL_MEDIA_CONFIG = {
  siteName: 'Bobo & Teedee®',
  defaultTitle: 'Bobo & Teedee® - Educational Adventures from the Cayman Islands',
  defaultDescription: 'Join Bobo the turtle and Teedee the iguana on educational adventures exploring Cayman Islands culture, values, and fun learning experiences for kids.',
  defaultImage: '/img/bobo-teedee-logo.png',
  twitterHandle: '@boboandteedee',
  
  // Page-specific configurations
  pages: {
    home: {
      title: 'Bobo & Teedee® - Educational Adventures from the Cayman Islands',
      description: 'Join Bobo the turtle and Teedee the iguana on educational adventures exploring Cayman Islands culture, values, and fun learning experiences for kids.',
      keywords: 'Bobo, Teedee, Cayman Islands, educational cartoon, kids entertainment, Caribbean culture, children education, turtle, iguana',
      image: '/img/bobo-teedee-logo.png',
    },
    activities: {
      title: 'Kids Corner Activities - Fun Learning with Bobo & Teedee®',
      description: 'Download free printable activities, worksheets, and educational games inspired by Bobo & Teedee adventures. Perfect for home learning and classroom use.',
      keywords: 'printable activities, kids worksheets, educational games, homeschool resources, classroom activities, Bobo Teedee activities, free downloads',
      image: '/img/bobo-teedee-logo.png',
    },
    episodes: {
      title: 'Watch Bobo & Teedee Episodes - Educational Caribbean Adventures',
      description: 'Watch full episodes of Bobo & Teedee, the educational cartoon series from the Cayman Islands featuring fun adventures and valuable life lessons.',
      keywords: 'Bobo Teedee episodes, educational videos, Caribbean cartoon, kids TV show, Cayman Islands stories, children entertainment',
      image: '/img/bobo-teedee-logo.png',
    },
    characters: {
      title: 'Meet the Characters - Bobo & Teedee® Adventure Friends',
      description: 'Meet Bobo the wise turtle, Teedee the energetic iguana, and all their colorful friends in this diverse cast of Caribbean characters.',
      keywords: 'Bobo character, Teedee character, Caribbean characters, diverse cast, educational cartoon characters, turtle iguana',
      image: '/img/bobo-teedee-logo.png',
    },
    about: {
      title: 'About Bobo & Teedee® - Educational Entertainment from the Cayman Islands',
      description: 'Learn about the mission behind Bobo & Teedee, the educational cartoon series that celebrates Caribbean culture while teaching valuable life lessons.',
      keywords: 'about Bobo Teedee, educational mission, Caribbean culture, Cayman Islands education, children programming, diverse representation',
      image: '/img/bobo-teedee-logo.png',
    },
    culture: {
      title: 'Cayman Islands Culture - Learn with Bobo & Teedee®',
      description: 'Explore the rich culture, traditions, and heritage of the Cayman Islands through engaging stories and educational content.',
      keywords: 'Cayman Islands culture, Caribbean traditions, cultural education, heritage learning, island life, tropical culture',
      image: '/img/bobo-teedee-logo.png',
    },
    partners: {
      title: 'Our Partners - Bobo & Teedee® Educational Collaborations',
      description: 'Meet our educational partners and sponsors who help bring Bobo & Teedee adventures to children around the Caribbean and beyond.',
      keywords: 'educational partners, sponsors, collaborations, educational institutions, Caribbean partnerships',
      image: '/img/bobo-teedee-logo.png',
    },
    contact: {
      title: 'Contact Us - Get in Touch with Bobo & Teedee®',
      description: 'Have questions about Bobo & Teedee? Want to partner with us? Get in touch with our team for educational collaborations and inquiries.',
      keywords: 'contact Bobo Teedee, educational partnerships, inquiries, collaboration opportunities, customer support',
      image: '/img/bobo-teedee-logo.png',
    },
  },
};

export const getSocialMediaConfig = (pageName: keyof typeof SOCIAL_MEDIA_CONFIG.pages) => {
  const pageConfig = SOCIAL_MEDIA_CONFIG.pages[pageName];
  return {
    ...pageConfig,
    siteName: SOCIAL_MEDIA_CONFIG.siteName,
    twitterHandle: SOCIAL_MEDIA_CONFIG.twitterHandle,
  };
};
